import { render } from "./ReplicaEditor.vue?vue&type=template&id=2dfb25e0&scoped=true"
import script from "./ReplicaEditor.vue?vue&type=script&lang=ts"
export * from "./ReplicaEditor.vue?vue&type=script&lang=ts"

import "./ReplicaEditor.vue?vue&type=style&index=0&id=2dfb25e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2dfb25e0"

export default script